module.exports = __webpack_public_path__ + "static/media/get_in_touch_2.97b00494.png";